import * as actionTypes from './../constants/actionTypes';
import { fetchStones } from './../actions';
import { fetchData as fetchProjectScopeData } from './../components/ProjectScope/ProjectScopeActions';

function fetchActiveWindow(dispatch, state) {
  switch(state.routing.locationBeforeTransitions.pathname) {
    case "/features":
    case "/scope":
      return dispatch(fetchProjectScopeData());
    case "/stones":
    case "/profile":
      return dispatch(fetchStones());
    default:
      return Promise.resolve([]);
  }
}

export function savePendingUpdates(keepChanges = false) {
  return (dispatch, getState) => {
    let state = getState();
    const { auth, asCustomer } = state;
    dispatch({
      type: actionTypes.POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: 'Saving...',
        message: 'Please wait while we are storing your changes.'
      }
    });
    return new Promise(resolve => {
      dispatch({
        type: actionTypes.SAVE_TRANSIENT_UPDATES,
        payload: {
          state,
          callback: resolve,
          auth,
          asCustomer
        }
      });
    })
      .then(() => dispatch(cancelPendingUpdates(false, keepChanges)));
  }
}

export function cancelPendingUpdates(saving = false, keepChanges = false) {
  return (dispatch, getState) => {
    let state = getState();
    const { auth } = state;

    return new Promise(resolve => {
      dispatch({
        type: actionTypes.CLEAR_TRANSIENT_UPDATES,
        payload: {
          auth,
          callback: resolve,
          saving,
          keepChanges
        }
      });
    })
      .then(() => fetchActiveWindow(dispatch, state))
      .then(() => dispatch({
        type: actionTypes.POPUP_IN_PROGRESS,
        payload: {
          show: false,
          title: '',
          message: ''
        }
      }));
  }
}
